// extracted by mini-css-extract-plugin
export default {"title":"header_title__cCYMB","starred":"header_starred__EC2EE","starredContainer":"header_starredContainer__8rhQJ","contents":"header_contents__bKla0"};